import React, {useEffect, useState} from 'react';
import style from './style.scss'
import newId from '../../utils/newid';
import Label from './Label';
import update from "immutability-helper/index";


const OptionsPrice = ({field, handleChange}) => {
    const {options} = field;
    return (
        <div>
            <table>
                <tr>
                    <th> Option </th>
                    <th> Price </th>
                </tr>
                {options.map((e, i) => {
                  // console.log(e.price);
                    return (<tr>
                        <td className={style.imageOptionPrice} >{e.image&&<img src={e.thumb&&e.thumb!=='null'&&e.thumb!==''&&e.thumb || e.image} />}{e.label}</td>
                        <td><input
                            type="text"
                            value={typeof e.price !== "undefined" ? e.price : ''}
                            onChange={(t) => {
                                return handleChange(update(field, {options: {[i]: {price: {$set: t.target.value}}}}))

                            }}

                        /></td>
                    </tr>)
                })}
            </table>
        </div>
    )

};


const RenderPrice = (props) => {
    const {item, field, validateField, isReadOnly, type = "text"} = props;
    const id = newId();

    let isOptPrice = false;
    if (typeof field.priceOptions !== 'undefined' && field.priceOptions === 'different_for_all') {
        isOptPrice = true;
    }
    const hasError = field.error && field.error[item.item] && true;
    return (
        isOptPrice ? <OptionsPrice {...props} /> :
            <div className={style.typeText + " " + (hasError ? style.hasError : '')}>
                {
                    (typeof item.label !== 'undefined') &&
                    <Label
                        id={id}
                        parentClass
                        label={item.label}
                    />}
                    { /* console.log(field) */ }
                <input
                    type={type}
                    id={id}
                    className={style.input}
                    // value={(typeof field !== "undefined") && field[item.item]}
                    value={field.price}
                    onChange={(t) => {
                        return props.handleChange(update(field, {price: {$set: t.target.value}}))

                    }}

                    readOnly={isReadOnly}
                />
                {item.label && item.label.second && <span className={style.secondLabel}>{item.label.second}</span>}

            </div>
    )
}

export default RenderPrice;
